<div *ngIf="collection" class="container" #container>
    <div class="interaction-menu-container d-none d-sm-none d-md-none d-lg-none d-xl-block">
        <ng-container *ngTemplateOutlet="interactionControls"></ng-container>
    </div>
    <div class="wrapper">
        <img
            [src]="heroImage.src"
            class="background-image"
            [ngClass]="{
                'd-none d-md-block d-lg-block d-xl-none': isCollectionHomePage,
            }"
            [alt]="heroAlt"
        />
        <div class="content">
            <div>
                <div class="top-region">
                    <div class="main-logo">
                        <img
                            *ngIf="whiteLogoURL"
                            [src]="whiteLogoURL"
                            class="white-version"
                            [alt]="whiteLogoAlt"
                        />
                        <img
                            *ngIf="colorLogoURL"
                            [src]="colorLogoURL"
                            class="dark-version"
                            [alt]="colorLogoAlt"
                        />
                        <div *ngIf="!colorLogoURL && !whiteLogoURL" class="main-title">
                            {{ collection.title }}
                        </div>
                    </div>
                    <div class="interaction-menu-container d-xl-none text-xs-center">
                        <ng-container *ngTemplateOutlet="interactionControls"></ng-container>
                    </div>
                </div>
                <div class="median-region">
                    <div class="main-description">
                        <div class="text" innerHTML="{{ collection.description }}"></div>
                        <app-read-more
                            text="{{ collection.description }}"
                            displayedCharsLimit="116"
                        ></app-read-more>
                    </div>
                    <div
                        class="resources-description"
                        [ngClass]="{
                            'd-flex align-items-md-center align-items-xs-start flex-xs-column flex-md-row justify-content-between':
                                isStudentExperience,
                        }"
                    >
                        <div class="resource-description-placeholder">
                            {{ resourcesDescription }}
                        </div>
                        <div
                            class="ms-md-4 ms-lg-6 mt-xs-4 mt-md-1 d-flex grade-toggle"
                            *ngIf="
                                isStudentExperience &&
                                (collection.hasFeaturedResources || collection.parentCollectionSlug)
                            "
                        >
                            Filtered by:
                            <app-slide-toggle
                                class="ms-2"
                                *ngIf="toggleOptions.length"
                                [values]="toggleOptions"
                                (optionChangeEmitter)="toggleGrades($event)"
                            >
                            </app-slide-toggle>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bottom-region">
                <div *ngIf="isCollectionHomePage" class="search-wrapper">
                    <div class="title">Search</div>
                    <app-search-collection-input
                        [placeholder]="'Search ' + collection.title"
                        [disableAutocomplete]="true"
                        [collection]="collectionSlug"
                    >
                    </app-search-collection-input>
                </div>
                <div class="jump-to-wrapper">
                    <app-jump-to-section
                        sectionTitle="{{ jumpToSectionTitle }}"
                        [buttonsList]="
                            isCollectionHomePage ? collection.sections : collection.topics
                        "
                        [isCollectionHomePage]="isCollectionHomePage"
                        [colors]="collection.colors"
                    >
                    </app-jump-to-section>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #interactionControls>
    <div class="interaction-menu-wrapper align-items-lg-end mb-xs-2 mb-lg-0">
        <app-link-button
            [tooltip]="isInPreviewMode ? '' : 'Share to Google Classroom.'"
            class="gtm-share-google-classroom selenium-share-google-classroom share-resource-item ms-2 me-2"
            label="Share to Google Classroom"
            [attr.data-gtmlabel]="collection.title + ' Premium Collection'"
            [classList]="windowSize.isDesktop ? 'GC-icon-desktop' : 'GC-icon-small-device'"
            [disable]="isInPreviewMode"
            [ngClass]="{ 'preview-color': isInPreviewMode }"
            (trigger)="shareToGoogleClassroom()"
        >
            <img [src]="googleClassroomImagePath" class="height-img" alt="Google Classroom" />
        </app-link-button>
        <app-link-button
            [tooltip]="isInPreviewMode ? '' : 'Share to Remind, email, Facebook and more.'"
            class="gtm-share-assign selenium-share-assign ms-4 me-4"
            label="Social Share"
            icon="Share-Social"
            [classList]="'share-button'"
            [attr.data-gtmlabel]="collection.title + ' Premium Collection'"
            [disable]="isInPreviewMode"
            [ngClass]="{ 'preview-color': isInPreviewMode }"
            (trigger)="openShareModal(collection.title)"
        >
        </app-link-button>
        <app-favorite-button
            [learningObjectId]="collection.loId"
            class="ms-4 me-4"
            [loggedoutTooltip]="isInPreviewMode ? '' : 'Sign in to save this collection for later.'"
            [loggedinTooltip]="isInPreviewMode ? '' : 'Save this collection for later.'"
            [gtmLabel]="collection.title + ' Premium Collection'"
            [disable]="isInPreviewMode"
            [ngClass]="{ 'preview-color': isInPreviewMode }"
        >
        </app-favorite-button>
    </div>
</ng-template>
